import {ActionFailure} from './approvalOutbox'
import type {Item} from './model'
import {continuationAvailable} from './recoveryView'
export type ChatAction='chat_send'|'chat_continue'|'owner_instruction'
export const messageAction=(item:Item,resume:boolean):ChatAction=>resume&&continuationAvailable(item)?'owner_instruction':'chat_send'
// Free-text continuation never smuggles legacy answers into an approval.
export function messagePayload(action:ChatAction,id:string,expected_job:string,message_id:string,message:string,decision_id:string|undefined,answers:Record<string,unknown>){
 return {id,expected_job,message_id,message,...(action==='owner_instruction'?{}:{decision_id,answers})}
}

export function restoredMessageMode(item:Pick<Item,'active_job'>,draft?:{stage:string;resume?:boolean}){return draft?.stage===item.active_job?draft.resume:undefined}
export function retryMessageId(action:ChatAction,error:unknown,current:string){return action==='owner_instruction'&&error instanceof ActionFailure&&error.definitive?crypto.randomUUID():current}
